import { gql } from 'graphql.macro';

const orderFormFieldTextValueFragment = gql`
    fragment orderFormFieldTextValue on OrderFormTextField {
        bounds {
            x
            y
        }
        regions {
            x0
            y0
            x1
            y1
            text
        }
        confidence
        value
    }
`;

export const orderFormFieldsFragment = gql`
    fragment orderFormFields on OrderFormFields {
        patientPersonalIdentityNumber {
            ...orderFormFieldTextValue
        }
        isValidPinFormat
        patientFirstName {
            ...orderFormFieldTextValue
        }
        patientLastName {
            ...orderFormFieldTextValue
        }
        clinicName {
            ...orderFormFieldTextValue
        }
        dentistFirstName {
            ...orderFormFieldTextValue
        }
        dentistLastName {
            ...orderFormFieldTextValue
        }
        constructionComment {
            ...orderFormFieldTextValue
        }
        constructionColor {
            ...orderFormFieldTextValue
        }
        deliveryDate {
            ...orderFormFieldTextValue
        }
        deliveryTime {
            ...orderFormFieldTextValue
        }
    }
    ${orderFormFieldTextValueFragment}
`;

export const restorationDataFragment = gql`
    fragment restorationDataFields on RestorationData {
        restorationType
        teeth
        teethRange {
            from
            to
        }
        jaw
        material
        color
        isTemporary
        isWarranty
    }
`;
